
import { mapState, mapActions } from 'vuex';

export default {
  i18nComponentKey: 'ReviewsShow.components.ProductReviewThumbnailsSection',
  name: 'ProductReviewThumbnailsSection',
  props: {
    currentReview: { type: Object, required: true },
    selectedIndex: { type: Number, default: null },
    fields: { type: String, default: null }
  },
  data() {
    return { REVIEW_THUMBNAILS_PER_PAGE: 12, currentPage: 1 };
  },
  computed: {
    ...mapState('productReviewThumbnails', {
      thumbnailReviews: 'reviews'
    }),
    ...mapState('productReviewThumbnails', [
      'isLoadingProductReviewThumbnails',
      'pagy',
      'totalPageCount'
    ]),
    thumbnailClicked() {
      return !!this.selectedIndex;
    },
    currentPageReviews() {
      return this.thumbnailReviews.slice(
        this.REVIEW_THUMBNAILS_PER_PAGE * (this.currentPage - 1),
        this.REVIEW_THUMBNAILS_PER_PAGE * this.currentPage
      );
    },
    enablePrev() {
      return this.currentPage > 1;
    },
    enableNext() {
      return (
        !this.isLoadingProductReviewThumbnails &&
        this.currentPage < this.totalPageCount
      );
    }
  },
  watch: {
    currentReview(newReview, oldReview) {
      if (newReview.id === oldReview.id) return;
      if (!this.thumbnailClicked)
        this.fetchProductReviewThumbnails({
          review_id: newReview.id,
          fields: this.fields + ',preload_pages'
        }).then(() => (this.currentPage = this.pagy.page));
    }
  },
  created() {
    if (!this.thumbnailClicked)
      this.fetchProductReviewThumbnails({
        review_id: this.currentReview.id,
        fields: this.fields + ',preload_pages'
      }).then(() => (this.currentPage = this.pagy.page));
  },
  methods: {
    ...mapActions('productReviewThumbnails', ['fetchProductReviewThumbnails']),
    onClickThumbnail(index) {
      this.$emit(
        'change',
        this.REVIEW_THUMBNAILS_PER_PAGE * (this.currentPage - 1) + index
      );
    },
    onPrev() {
      if (!this.enablePrev) return;

      this.currentPage--;
    },
    onNext() {
      if (!this.enableNext) return;

      if (this.currentPage + 1 === this.pagy.next) {
        this.fetchProductReviewThumbnails({
          product_code: this.currentReview.product_code,
          page: this.pagy.next,
          fields: this.fields,
          append: true
        }).then(() => (this.currentPage = this.pagy.page));
      } else {
        this.currentPage++;
      }
    }
  }
};
